import React from 'react'
import ReactDOM from 'react-dom/client'
import { LicenseInfo } from '@mui/x-license'
import { AuthProvider, type AuthProviderProps } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { AuthTokenProvider } from "./providers/auth-provider";
import { ThemeProvider } from "./providers/theme-provider";
import "./index.css";
import { appConfig } from "./config/app-config";
import App from './App.tsx'
// Configurar la licencia de MUI Pro ANTES de renderizar
// Esto es crítico: la licencia debe estar configurada antes de que se renderice cualquier componente Pro
const licenseKey = import.meta.env.VITE_MUI_LICENSE_KEY
if (licenseKey) {
  try {
    LicenseInfo.setLicenseKey(licenseKey)
  } catch (error) {
  }
} else {
}
const oidcConfig: AuthProviderProps = {
  authority: appConfig.oidc.authority,
  client_id: appConfig.oidc.clientId,
  redirect_uri: `${window.location.origin}/${appConfig.oidc.redirectPath}`,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: `${appConfig.oidc.scope} openid profile email`,
  automaticSilentRenew: true,
  loadUserInfo: true,
  // Manejar eventos de expiración de token
  onSigninCallback: () => {
    // Limpiar la URL después del callback para evitar problemas de navegación
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...oidcConfig}>
        <ThemeProvider>
          <CssBaseline />
          <AuthTokenProvider>
            <App />
          </AuthTokenProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
